<template>
  <div class="flex items-center">
    <input
      :id="id"
      type="checkbox"
      class="form-checkbox focus:ring-primary-500 h-4 w-4 text-primary-500 border-gray-300 rounded"
      @change="handleChange"
      :checked="isChecked"
      :disabled="disabled"
      :value="value"
    />
    <label :for="id" class="font-thin text-sm ml-3 mb-0" v-if="label || $slots.default">
      <slot>
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  emits: ["update:modelValue"],
  props: {
    label: String,
    modelValue: { type: [Array, Boolean], default: false }, // Supports both arrays and booleans
    value: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      id: `checkbox-${uuidv4()}`,
    };
  },
  computed: {
    isChecked() {
      if (typeof this.modelValue === "boolean") {
        return this.modelValue; // If boolean, return as-is
      }
      return Array.isArray(this.modelValue) && this.modelValue.includes(this.value);
    },
  },
  methods: {
    handleChange(event) {
      if (typeof this.modelValue === "boolean") {
        this.$emit("update:modelValue", !this.modelValue); // Toggle boolean value
        return;
      }

      if (!Array.isArray(this.modelValue)) return;

      const val = event.target.value;
      const copy = [...this.modelValue];
      const existingIndex = copy.indexOf(val);

      if (existingIndex >= 0) {
        copy.splice(existingIndex, 1);
      } else {
        copy.push(val);
      }

      this.$emit("update:modelValue", copy);
    },
  },
};
</script>
